import "./theme/_counter.scss"

(($) => {
  const fixFLoat = (value, decimal) => {
    return parseFloat(value.toFixed(decimal))
  }

  const floatToLocalString = (value, decimal) => {
    return fixFLoat(value, decimal).toLocaleString(undefined, { minimumFractionDigits: decimal })
  }

  let counters = document.querySelectorAll('.counter')
  counters.forEach(counter => {

    let counterStart = parseFloat(counter.dataset.counterStart)
    let counterEnd = parseFloat(counter.dataset.counterEnd)
    let animation = null;

    // decimal from endNumber
    // exponent: 10^decimal
    let decimal = counter.dataset.counterEnd.length - (counter.dataset.counterEnd.indexOf('.') + 1)
    decimal = counter.dataset.counterEnd.length !== decimal ? decimal : 0
    let decimalFactor = Math.pow(10, decimal)

    // set place holder value depending on longest
    if(counter.dataset.counterEnd.length > counter.dataset.counterStart.length) {
      counter.style.setProperty(
        '--counter-placeholder-formated',
        '"' + floatToLocalString(counterEnd, decimal) + '"'
      )
    } else {
      counter.style.setProperty(
        '--counter-placeholder-formated',
        '"' + floatToLocalString(counterStart, decimal) + '"'
      )
    }

    counter.addEventListener('intersect', event => {

      // define animation parameters
      let duration, start, end

      if (event.detail.isIntersecting) {
        duration = 5060
        start = counter.dataset.counterValue ? parseFloat(counter.dataset.counterValue) : counterStart
        end = counterEnd
      } else {
        duration = 130
        start = counter.dataset.counterValue ? parseFloat(counter.dataset.counterValue) : counterEnd
        end = counterStart
      }

      let dt = end - start

      // animate
      if (animation) {
        animation.stop();
      }
      animation = $({
        progress: 0
      }).animate({
        progress: 1
      }, {
        duration: duration,
        easing: 'linear',
        step: function() {
          // easing
          // see: https://easings.net/#easeOutCirc
          let factor = Math.sqrt(1 - Math.pow(this.progress - 1, 2))
          let value = start + dt * factor
          // floor value to decimal so counter stops at the same time 
          value = Math.floor(value * decimalFactor) / decimalFactor;
          counter.style.setProperty(
            '--counter-value-formated',
            '"' + floatToLocalString(value, decimal) + '"'
          )
          counter.dataset.counterValue = value;
        },
        complete: function() {
          counter.style.setProperty(
            '--counter-value-formated',
            '"' + floatToLocalString(end, decimal) + '"'
          )
          counter.dataset.counterValue = end;
        }
      })
    });
  });

  
})(jQuery)
